<template>
  <div v-if="$userInfo.isSystemAdministrator">
    <app-detail-header :show-toggle="false"
      :show-new="false"
      :show-print="false"
      :show-delete="false"
      :show-save="false"
      :show-lock="false"
      :show-cancel="false"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column">
        <router-view ref="currentChild" />
      </div>
    </div>
  </div>
  <div v-else
    class="is-flex is-justify-content-center pt-5">
    <div class="notification is-danger is-flex is-justify-content-center is-size-4"
      style="width: 50%">You do not have permissions on this page</div>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import { AppHeaderButtonTypes } from '@/enums'
import StoreMixin from './storeMixin'

export default {
  name: 'SystemMessageView',
  components: {
    AppDetailHeader
  },
  mixins: [StoreMixin],
  data() {
    return {}
  },
  methods: {
    async onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          if (this.$refs.currentChild && this.$refs.currentChild.getEntity) {
            await this.$refs.currentChild.reset()
            await this.$refs.currentChild.getEntity()
          }
          break
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          break
        case AppHeaderButtonTypes.Save:
          break
        case AppHeaderButtonTypes.Cancel:
          break
      }
    }
  }
}
</script>

<style scoped>
</style>

